import { render } from "./Navigation.vue?vue&type=template&id=4e139073&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=4e139073&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Navigation.vue?vue&type=custom&index=0&blockType=li&class=nav-item"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\Htet Win Khant\\Desktop\\Light Idea\\WebFlashMallRestaurant360DegreeRestaurant-\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e139073"]])

export default __exports__